import { DataBean } from "../DataBean";

export class CreateEgress extends DataBean {



    public async createEgressDocumentForIncomeDocument(IDDocument:any,DocumentDate:any,accountantDate:any,idAccount:any,idCashDeskAccount:any,idBankingAccount:any,toCompensateValue:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createEgressDocumentForIncomeDocument_Number_java.util.Date_java.util.Date_Number_Number_Number_Number_String_Number", [IDDocument,DocumentDate,accountantDate,idAccount,idCashDeskAccount,idBankingAccount,toCompensateValue,description,idEmployee]);
    }
}